/** @format */
import angular from 'angular';
import 'ngclipboard';
import { logModule } from '../log.module';
import { errorServiceModule } from './errorService';

export const errorHandlerModule = 'sis-common.errorhandler';

(function () {
    angular.module(errorHandlerModule, [errorServiceModule, logModule, 'ngclipboard']);
})();
